import React, {memo} from 'react';
import {
    CONTROL_TYPE_ID_ANALOG,
    CONTROL_TYPE_ID_DIMMER,
    CONTROL_TYPE_ID_DIMMER_COLOR,
    CONTROL_TYPE_ID_THERMOSTAT,
    CONTROL_TYPE_ID_FANCOIL,
    ControlModel,
    ControlTypeModel,
    ThreePhaseSet,
    CONTROL_TYPE_ADV_THERMOSTAT,
    CONTROL_TYPE_ID_VRF,
    CONTROL_TYPE_GENERAL_TEMPERATURE,
    HideControlParameters,
} from '../../types/control';
import {useSelector} from 'react-redux';
import {SimpleControl} from '../SimpleControl';
import {ThreePhaseControl} from '../ThreePhaseControl';
import {DimmerControl} from '../Controls/DimmerControl';
import {TemperatureControl} from '../Controls/TemperatureControl';
import {FanCoilControl} from "../Controls/FanCoilControl";
import {DimmerWithRGBControl} from "../Controls/DimmerWithRGBControl";
import {RGBPicker} from '../Controls/ColorPicker';
import {VRFControl} from '../Controls/VRF';
import {DefaultTemperature} from '../Controls/DefaultTemperature';

const renderById = (control: ControlModel, controlType: ControlTypeModel<unknown>) => {
    switch (control.type_id) {
        case CONTROL_TYPE_ID_DIMMER: {
            return (
                <DimmerControl
                    controlType={controlType as ControlTypeModel}
                    key={`control_${control.id}`}
                    control={control}/>
            );
        }

        case CONTROL_TYPE_ID_ANALOG: {
            return (
                <DimmerControl
                    controlType={controlType as ControlTypeModel}
                    key={`control_${control.id}`}
                    control={control}/>
            );
        }

        case CONTROL_TYPE_ID_DIMMER_COLOR: {
            return (
                <RGBPicker

                    controlType={controlType as ControlTypeModel}
                    key={`control_${control.id}`}
                    control={control}/>
            );
        }

        case CONTROL_TYPE_ID_THERMOSTAT: {
            return (
                <TemperatureControl
                    key={`control_${control.id}`}
                    control={control}/>
            );
        }

        case CONTROL_TYPE_ID_FANCOIL: {
            return (
                <FanCoilControl
                    key={`control_${control.id}`}
                    control={control}/>
            );
        }

        case CONTROL_TYPE_ADV_THERMOSTAT: {
            return (
                <TemperatureControl
                    key={`control_${control.id}`}
                    control={control}/>
            );
        }

        case CONTROL_TYPE_ID_VRF: {
            return (
                <VRFControl
                    key={`control_${control.id}`}
                    control={control}/>
            );
        }

        case CONTROL_TYPE_GENERAL_TEMPERATURE: {
            return (
                <DefaultTemperature
                    key={`control_${control.id}`}
                    control={control}/>
            );
        }
    }

    return null;
};

export const Control = memo(function Item({control}: { control: ControlModel }) {
    const controlType = useSelector(
        state => state.control.controlTypeList.find(t => t.id === control?.type_id && !(control?.parameters as HideControlParameters)?.hide_control),
    );

    if (controlType == null) {
        return null;
    }

    if (controlType.render_type === 'simple' || controlType.render_type === 'pulse') {
        return (
            <SimpleControl
                control={control}
                controlType={controlType as ControlTypeModel}
            />
        );
    }

    if (controlType.render_type === 'three_phase'|| controlType.render_type === 'two_phase') {
        return (
            <ThreePhaseControl
                controlType={controlType as ControlTypeModel<ThreePhaseSet>}
                control={control}
            />
        );
    }

    return renderById(control, controlType);
});
